import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    url: String
  }
  static targets = ["canvas", "rangeSelect", "granularitySelect"]

  connect() {
    this.loadChart()
  }

  async loadChart() {
    // Load Chart.js from CDN
    await this.loadChartJS()
    
    // Build URL with parameters
    const params = new URLSearchParams()
    if (this.hasRangeSelectTarget) {
      params.append('range', this.rangeSelectTarget.value)
    }
    if (this.hasGranularitySelectTarget) {
      params.append('granularity', this.granularitySelectTarget.value)
    }
    
    const url = `${this.urlValue}?${params.toString()}`
    
    // Fetch the data
    const response = await fetch(url)
    const data = await response.json()
    
    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }
    
    // Create the chart
    const ctx = this.canvasTarget.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.labels,
        datasets: [{
          label: 'Average Response Time (ms)',
          data: data.data,
          borderColor: 'rgb(59, 130, 246)', // Blue color matching the UI
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: data.message ? true : false,
            text: data.message || '',
            font: {
              size: 14,
              weight: 'normal'
            },
            color: 'rgb(156, 163, 175)' // Gray color for the message
          },
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Response Time (ms)'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Time'
            }
          }
        }
      }
    })
  }

  // Called when range or granularity changes
  refresh() {
    this.loadChart()
  }

  loadChartJS() {
    return new Promise((resolve) => {
      if (window.Chart) {
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.0/dist/chart.umd.js'
      script.onload = resolve
      document.head.appendChild(script)
    })
  }
}